"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _borderRadius = require("../../../styles/borderRadius");

var _colors = require("../../../styles/colors");

var _shadows = require("../../../styles/shadows");

var _fontSizes = require("../../../styles/fontSizes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    text-decoration: none;\n    transition: color 0.1s linear;\n    cursor: pointer;\n    height: 2rem;\n    width: 2rem;\n    border-radius: ", ";\n    font-weight: bold;\n    font-size: ", ";\n    line-height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n    outline: none;\n\n    :focus,\n    :active {\n        box-shadow: ", ";\n        background-color: ", ";\n        outline: none;\n    }\n\n    :hover {\n        color: ", ";\n        background-color: ", ";\n        text-decoration: none;\n        outline: 0;\n    }\n\n    &:focus,\n    &:active,\n    &:visited {\n        font-size: ", ";\n        text-decoration: none;\n        color: ", ";\n        background-color: ", ";\n        z-index: 100;\n        outline: 0;\n    }\n\n    ", ";\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = _styledComponents["default"].a(_templateObject(), _borderRadius.BORDER_RADIUS_2, _fontSizes.FONT_SIZE_TEXT_MEDIUM, _colors.COLOR_WHITE, _colors.COLOR_GRAY_2, _colors.COLOR_GRAY_4, _shadows.SHADOW_OUTLINE, _colors.COLOR_WHITE, _colors.COLOR_GRAY_4, _colors.COLOR_GRAY_1, _fontSizes.FONT_SIZE_TEXT_LARGE, _colors.COLOR_DARK_1, _colors.COLOR_GRAY_2, function (props) {
  return props.isActivePage && "\n            font-size: ".concat(_fontSizes.FONT_SIZE_TEXT_LARGE, ";\n            text-decoration: none;\n            color: ").concat(_colors.COLOR_DARK_1, ";\n            background-color: ").concat(_colors.COLOR_GRAY_2, ";\n            z-index: 100;\n\n            :hover {\n                background-color: ").concat(_colors.COLOR_GRAY_2, ";\n                color: ").concat(_colors.COLOR_DARK_1, ";\n            }\n        ");
}, function (props) {
  return props.disabled && "\n            background-color: transparent;\n            pointer-events: none;\n        \n            &:hover {\n                background-color: transparent;\n                pointer-events: none;\n            }\n        \n            &:focus,\n            &:active {\n                background-color: transparent;\n                pointer-events: none;\n                z-index: 100;\n            }\n\n            > svg {\n                fill: ".concat(_colors.COLOR_GRAY_2, ";\n        ");
});

var _default = StyledButton;
exports["default"] = _default;